<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="模板ID" prop="templateId"><el-input v-model="form.templateId" placeholder="模板ID" /></el-form-item>
      <el-form-item label="编码" prop="templateCode"><el-input v-model="form.templateCode" placeholder="编码" /></el-form-item>
      <el-form-item label="字体" prop="fontFamily"><el-input v-model="form.fontFamily" placeholder="字体" /></el-form-item>
      <el-form-item label="背景色" prop="bgColor"><el-input v-model="form.bgColor" placeholder="背景色" /></el-form-item>
      <el-form-item label="文字色" prop="textColor"><el-input v-model="form.textColor" placeholder="文字色" /></el-form-item>
      <el-form-item label="强调色" prop="accentColor"><el-input v-model="form.accentColor" placeholder="强调色" /></el-form-item>
      <el-form-item label="背景图" prop="bgImage"><el-input v-model="form.bgImage" placeholder="背景图" /></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operatemplateStyleWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, templateId: '', templateCode: '', fontFamily: '', bgColor: '', textColor: '', accentColor: '', bgImage: '' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/templateStyle', 'field.id': 'id' }) }
}
</script>